import { MultiSessionDeviceSubs } from 'reactApp/appHelpers/featuresHelpers/features/multiSessionSubscriptions';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { getCurrentSubscriptionPeriod, getNextSubsctiptionPeriod } from 'reactApp/modules/billingData/billingData.utils';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { formatLocale } from 'reactApp/utils/formatDate';
import { addPeriodToDate, getPeriodName } from 'reactApp/utils/Period';
import { computersGenitive, computersNominative } from 'reactApp/utils/pluralHelpers';

import type { BeforeRenewModalProps } from './BeforeRenewModal';

const formatSubsDate = (date) => formatLocale(date, 'dd MMMM yyyy');

export const renderBeforeRenewModal = ({ onClose, ...data }: BeforeRenewModalProps) =>
    openPopupHelper({ popupName: popupNames.BEFORE_RENEW_MODAL, data, onClose });

export const closeBeforeRenewModal = () => closePopupHelper(popupNames.BEFORE_RENEW_MODAL);

export const BeforeRenderModalTexts = {
    getTitle: (subscription: BillingDataSubscriptionInfo) => {
        return `Подписка активна до\u00A0${formatSubsDate(subscription.expires)}.`;
    },
    getTitleQuestion: (subscription: BillingDataSubscriptionInfo) => {
        const nextPeriod = getNextSubsctiptionPeriod(subscription);
        if (nextPeriod) {
            return `Продлить ещё на\u00A0${getPeriodName(nextPeriod, true, true)}?`;
        }
        return null;
    },
    getContentRenewalText: (subscription: BillingDataSubscriptionInfo) => {
        const nextPeriod = getNextSubsctiptionPeriod(subscription);
        const parsedNextPeriod = nextPeriod && addPeriodToDate(subscription.expires, nextPeriod);
        if (parsedNextPeriod) {
            return `Если продлить, она будет активна до\u00A0${formatSubsDate(parsedNextPeriod)}`;
        }
        return null;
    },
    getContentText: (subscription: BillingDataSubscriptionInfo) => {
        const currentPeriod = getCurrentSubscriptionPeriod(subscription);
        return `Вы\u00A0уже оплатили +${subscription.space.value} Mail Space на\u00A0${getPeriodName(currentPeriod, false, true)}.`;
    },
} as const;

export const MultiSessionFreeChoiceModalTexts = {
    ...BeforeRenderModalTexts,
    getContentRenewalText: (_: BillingDataSubscriptionInfo) => {
        return null;
    },
    getContentText: (subscription: BillingDataSubscriptionInfo) => {
        const currentPeriod = getCurrentSubscriptionPeriod(subscription);
        const devices = MultiSessionDeviceSubs.getDeviceCount(subscription.productId);
        return `Вы\u00A0уже\u00A0оплатили вход в\u00A0Почту с ${devices} ${computersGenitive(devices)} на\u00A0${getPeriodName(
            currentPeriod,
            false,
            true
        )}.`;
    },
};

export const MultiSessionPresetInSubsTexts = {
    ...BeforeRenderModalTexts,
    getTitle: (subscription: BillingDataSubscriptionInfo) => {
        return `Mail Space активна до\u00A0${formatSubsDate(subscription.expires)}.`;
    },
    getContentRenewalText: (_: BillingDataSubscriptionInfo) => {
        return null;
    },
    getContentText: (subscription: BillingDataSubscriptionInfo) => {
        const currentPeriod = getCurrentSubscriptionPeriod(subscription);
        const devices = MultiSessionDeviceSubs.getDeviceCount(subscription.productId);
        return `Вы\u00A0уже\u00A0оплатили подписку Для\u00A0работы и\u00A0вход в\u00A0Почту с ${devices} ${computersNominative(
            devices
        )} на\u00A0${getPeriodName(currentPeriod, false, true)}.`;
    },
};

/* tempexp_20582-start */
export const ImapAsPaidFeatureTexts = {
    getTitle: (subscription: BillingDataSubscriptionInfo) => {
        return `Подписка активна до\u00A0${formatSubsDate(subscription.expires)}.`;
    },
    getTitleQuestion: (subscription: BillingDataSubscriptionInfo) => {
        const nextPeriod = getNextSubsctiptionPeriod(subscription);
        if (nextPeriod) {
            return `Продлить ещё на\u00A0${getPeriodName(nextPeriod, true, true)}?`;
        }
        return null;
    },
    getContentRenewalText: () => {
        return null;
    },
    getContentText: (subscription: BillingDataSubscriptionInfo) => {
        const currentPeriod = getCurrentSubscriptionPeriod(subscription);
        return `Вы\u00A0уже\u00A0оплатили Создание паролей для\u00A0приложений на\u00A0${getPeriodName(currentPeriod, false, true)}`;
    },
};
/* tempexp_20582-end */
